var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview"},[(_vm.src)?_c('div',{staticClass:"preview__box"},[_c('img',{attrs:{"src":_vm.src,"alt":"preview"}})]):_c('div',{staticClass:"preview__empty"},[_vm._v("追加した画像がこちらに表示されます")])])}
var staticRenderFns = []

export { render, staticRenderFns }